import { Block } from 'ui-kit/blocks'
import { Actions, Link } from 'ui-kit/actions'
import { BookCalendlyLink } from 'routes/components/Shared'
import { DOCS_LINK } from 'routes/constants'
import { SelfHostingBenefits } from '../Benefits'
import { SelfHostingFeatures } from '../Features'
import classes from './SelfHostingAdvantages.module.scss'

export const SelfHostingAdvantages = () => {
  return (
    <Block as={'section'} className={classes.section}>
      <div className={classes.content}>
        <SelfHostingBenefits />
        <SelfHostingFeatures />
      </div>

      <Actions className={classes.actions}>
        <BookCalendlyLink type={'primary'} className={classes.button}>
          Book a demo
        </BookCalendlyLink>
        <Link
          href={`${DOCS_LINK}/getting-started/self-hosting`}
          type={'secondary'}
          target={'_blank'}
          asPageButton
          className={classes.button}
        >
          Read the self-hosting docs
        </Link>
      </Actions>
    </Block>
  )
}
